import "./MiamiDadeCountyHomeInspector.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import LandlordsIntro from "./sections/LandlordsIntro";
import NeighborhoodsCommunities from "./sections/NeighborhoodsCommunities";
import LetsStartWithARealConversation from "./sections/LetsStartWithARealConversation";
import Footer from "@/reusable_sections/Footer";
export default function MiamiDadeCountyHomeInspectorPage() {
  return <div>
      <Header />
      <Hero />
      <LandlordsIntro />
      <NeighborhoodsCommunities />
      <LetsStartWithARealConversation />
      <Footer />
    </div>;
}